import { useJobPostingContext } from '@/contexts/job-posting-context';

import { CampaignDetails } from './campaign-details';
import { JobDetails } from './job-details';
import { Summary } from './summary';

export function JobPostingFlow() {
  const { currentStep } = useJobPostingContext();

  return (
    <div className="flex flex-1 flex-col items-center gap-3 overflow-auto pb-6">
      {currentStep === 1 && <JobDetails />}
      {currentStep === 2 && <CampaignDetails />}
      {currentStep === 3 && <Summary />}
    </div>
  );
}
